import { render, staticRenderFns } from "./CreateSystemAssessment.vue?vue&type=template&id=4603428e&scoped=true"
import script from "./CreateSystemAssessment.vue?vue&type=script&lang=js"
export * from "./CreateSystemAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4603428e",
  null
  
)

export default component.exports